export function normalizeExternalUrl(
    raw: string | null | undefined,
): string | null {
    const trimmed = raw?.trim();
    if (!trimmed || /^[/\\]/u.test(trimmed)) return null;
    const href = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    try {
        const url = new URL(href);
        return url.hostname.includes(".") && !url.username && !url.password
            ? href
            : null;
    } catch {
        return null;
    }
}
